// extracted by mini-css-extract-plugin
export default {"root":"s3SggiTCXb9sIYlPV3TB"};